import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

interface DataRowProps {
  rowData: JSX.Element[] | undefined;
}

const DataRow: React.FC<DataRowProps> = ({ rowData }: DataRowProps) => {
  return (
    <TableRow>
      {rowData?.map((data, index) => {
        if (data === undefined) return; // check to conditionally render undefined table rows
        return (
          <TableCell key={index} align={index === rowData.length - 1 ? "right" : "left"}>
            {data}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default DataRow;
